(function () {
  'use strict';

  angular.module('app').component('searchRelatedBookings', searchRelatedBookings());

  function searchRelatedBookings() {
    return {
      bindings: {
        bill: '=',
        billProduct: '<',
        provider: '<',
        onBookingSelected: '&',
      },
      controller: SearchRelatedBookingsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/components/search-related-bookings/search-related-bookings.component.html',
    };
  }

  SearchRelatedBookingsComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'BookingService',
    'moment',
  ];

  function SearchRelatedBookingsComponent(CONFIG, UtilService, BookingService, moment) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.only_provider = true;
    vm.only_product = true;

    vm.d_prod = false; // TODO: what is d_prod?
    vm.d_provi = false;

    vm.index = 0; // what for ?

    vm.dateDisplay = CONFIG.DATE_DISPLAY_SHORT;
    vm.hourDisplay = CONFIG.HOUR_DISPLAY;

    vm.$onInit = function () {
      setServiceDatePickers();
      setInitialFilters();

      // Initializers
      getBookings();
    };

    // public methods
    // -----------------------
    vm.refresh = function () {
      setInitialFilters();

      getBookings();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      getBookings();
    };

    vm.getBooking = function (booking) {
      vm.loadingBooking = true;
      BookingService.getBooking(booking.id).then(function (data) {
        vm.booking = data;
        vm.loadingBooking = false;
      });
    };

    vm.searchAllProviders = function () {
      if (vm.allProviders) {
        vm.only_provider = false;
        delete vm.filterCriteria['provider_id'];
      } else {
        vm.filterCriteria.provider_id = vm.provider_id;
        vm.only_provider = true;
      }

      getBookings();
    };

    vm.searchAllProducts = function () {
      if (vm.allProducts) {
        delete vm.filterCriteria['product_id'];
        vm.only_product = false;
      } else {
        vm.filterCriteria.product_id = vm.billProduct.product_id;
        vm.only_product = true;
      }

      getBookings();
    };

    vm.selectAllBookingItems = function () {
      vm.booking.booking_items.forEach(function (bookingItem) {
        bookingItem.selected = vm.selectedAll;

        selectAllBookingItemServiceItems(bookingItem);
      });

      checkIfAtLeastOneBookingItemIsSelected();
    };

    vm.selectBookingItem = function (bookingItem) {
      selectAllBookingItemServiceItems(bookingItem);

      checkIfAtLeastOneBookingItemIsSelected();
    };

    vm.selectBookingItemServiceItem = function () {
      checkIfAtLeastOneBookingItemIsSelected();
    };

    vm.getBookingsbySearch = function () {
      if (vm.filterCriteria.by_search) {
        vm.only_provider = false;
        vm.only_product = false;
        vm.d_prod = true;
        vm.d_provi = true;
      } else {
        vm.d_prod = false;
        vm.d_provi = false;
      }

      return vm.filterCriteria.by_search;
    };

    vm.addSelectedItemsToBill = function () {
      var booking = {
        id: vm.booking.id,
        booking_number: vm.booking.booking_number,
        currency_id: vm.booking.currency_id,
        booking_items_selected: [],
      };

      vm.booking.booking_items.forEach(function (bookingItem) {
        var quantityBooked = 0;
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach(function (bookingItemServiceItem) {
            if (bookingItemServiceItem.selected) {
              quantityBooked =
                bookingItemServiceItem.service_item.cost_type === 'per_person'
                  ? bookingItemServiceItem.adults +
                    bookingItemServiceItem.children +
                    bookingItemServiceItem.infants +
                    bookingItemServiceItem.seniors
                  : 1;
              booking.booking_items_selected.push({
                id: bookingItem.id,
                product_id: bookingItemServiceItem.service_item.id,
                product_code: bookingItemServiceItem.service_item.code,
                product_cabys_code: bookingItemServiceItem.service_item.cabys_code,
                product_name: bookingItemServiceItem.service_item.name,
                purchase_taxes: bookingItemServiceItem.purchase_taxes,
                product_type: 'service_item',
                quantity_booked: quantityBooked,
                quantity_billed: bookingItemServiceItem.quantity_billed || 0,
                discount_cost_percentage: bookingItemServiceItem.discount_cost_percentage,
                tax_cost_percentage: bookingItemServiceItem.tax_cost_percentage,
                total_cost: bookingItemServiceItem.total_cost,
                measurement_unit_id: bookingItemServiceItem.measurement_unit_id,
                booking_item_service_item_id: bookingItemServiceItem.id,
              });
            }
          });
        } else {
          if (bookingItem.selected) {
            booking.booking_items_selected.push({
              id: bookingItem.id,
              product_id: bookingItem.detail.id,
              product_code: bookingItem.detail.code,
              product_cabys_code: bookingItem.detail.cabys_code,
              product_name: bookingItem.detail.name,
              product_type: bookingItem.booking_type,
              purchase_taxes: bookingItem.purchase_taxes,
              quantity_booked:
                bookingItem.adults +
                bookingItem.children +
                bookingItem.infants +
                bookingItem.seniors,
              quantity_billed: bookingItem.quantity_billed || 0,
              discount_cost_percentage: bookingItem.discount_cost_percentage,
              tax_cost_percentage: bookingItem.tax_cost_percentage,
              total_cost: bookingItem.total_cost,
              measurement_unit_id: bookingItem.measurement_unit_id,
            });
          }
        }
      });

      vm.onBookingSelected({ booking: booking });
    };

    // ?
    vm.onClear = function () {
      vm.only_product = true;
      vm.only_provider = true;
    };

    // private methods
    // -----------------------
    function setInitialFilters() {
      vm.filterCriteria = BookingService.getFilterCriteria();
      vm.filterCriteria.related_bookings = true;

      vm.filterCriteria.provider_id = vm.provider.id;
      vm.filterCriteria.product_id = vm.billProduct.product_id;

      // fix and make dynamic depending the product type // tour 'service_item'
      vm.filterCriteria.product_type = vm.billProduct.product_type;
      vm.filterCriteria.start_date = vm.serviceDatePicker.startDate;
      vm.filterCriteria.end_date = vm.serviceDatePicker.endDate;
    }

    function setServiceDatePickers() {
      vm.serviceDatePicker = {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
      };

      vm.serviceDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByServiceDate,
        rangeOptions: CONFIG.SERVICE_DATE_OPTIONS,
        dateDisplay: vm.dateDisplay,
        minDate: moment().subtract(60, 'days'),
        maxDate: moment().add(60, 'days'),
      });
    }

    function filterByServiceDate(option) {
      if (option === 'apply') {
        vm.filterCriteria.start_date = vm.serviceDatePicker.startDate.format();
        vm.filterCriteria.end_date = vm.serviceDatePicker.endDate.format();

        vm.serviceDatePickerApplied = true;

        vm.only_provider = false;
        vm.only_product = false;
      } else {
        vm.serviceDatePicker = {
          startDate: '',
          endDate: '',
        };

        delete vm.filterCriteria.start_date;
        delete vm.filterCriteria.end_date;

        vm.serviceDatePickerApplied = false;
      }

      getBookings();
    }

    function getBookings() {
      vm.selectedAll = false;
      vm.booking = null;

      vm.loadingBookings = true;
      BookingService.getBookings(vm.filterCriteria).then(function (data) {
        vm.bookings = data.items;

        vm.meta = data.meta;

        vm.loadingBookings = false;
      });
    }

    function selectAllBookingItemServiceItems(bookingItem) {
      if (!bookingItem.based_on_service_items) {
        return;
      }

      bookingItem.booking_item_service_items.forEach(function (bookingItemServiceItem) {
        bookingItemServiceItem.selected = bookingItem.selected;
      });
    }

    // Check if at least one booking item is selected, is is based on service item, check if at least on service item is selected
    function checkIfAtLeastOneBookingItemIsSelected() {
      var valid = false;

      var bookingItem, bookingItemServiceItem;
      if (vm.booking) {
        for (var i = 0; i < vm.booking.booking_items.length; i++) {
          bookingItem = vm.booking.booking_items[i];

          if (bookingItem.based_on_service_items) {
            var found = false;
            for (var j = 0; j < bookingItem.booking_item_service_items.length; j++) {
              bookingItemServiceItem = bookingItem.booking_item_service_items[j];

              if (bookingItemServiceItem.selected) {
                found = true;
                break;
              }
            }

            if (found) {
              valid = true;
              break;
            }
          } else {
            if (bookingItem.selected) {
              valid = true;
              break;
            }
          }
        }
      }

      vm.atLeastOneBookingItemIsSelected = valid;
    }
  }
})();
